import React, { useEffect, useState } from "react";
import { Alert, Badge, Box, Button, Card, Icon, Text } from "~/components-shared";
import lists from "~/lib/lists";
import { usePostHog } from "posthog-js/react";
import { useDispatch, useSelector } from "react-redux";
import trendReportsActionCreators from "~/store/trendReports/actions";
import { useTranslation } from "react-i18next";
import trendReportSelectors from "~/store/trendReports/selectors";
import toastsActionCreators from "~/store/toasts/actions";
import { StatusStateEnum } from "~/types/enums";
import styled from "styled-components";
const StyledBox = styled(Box)`
  position: absolute;
  top: 5px;
  right: 5px;
`;
const TrendingItemCard = _ref => {
  let {
    showDismissed,
    item,
    isEditable = false,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const posthog = usePostHog();
  const [itemState, setItemState] = useState(item);
  const dismissStatus = useSelector(trendReportSelectors.getStatusByTrend(item.id));
  const error = useSelector(trendReportSelectors.getErrorByTrend(item.id));
  const status = useSelector(trendReportSelectors.getStatusByReport(item.reportId));
  const dispatch = useDispatch();
  useEffect(() => {
    if (item.reportId && status === StatusStateEnum.IDLE) {
      dispatch(trendReportsActionCreators.fetchOneStarted(item.reportId));
    }
  }, [item.reportId, status]);
  if (!itemState || !showDismissed && itemState.isDismissed) {
    return null;
  }
  const handleToggleDismiss = () => {
    if (item.reportId) {
      dispatch(trendReportsActionCreators.dismissTrendStarted(item.reportId, item.id, undefined, _ref2 => {
        let {
          data
        } = _ref2;
        if (data) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TrendingItemCard.successfullyDismissed", {
              name: item?.name
            }),
            timeout: 10000
          }));
          setItemState(prev => ({
            ...prev,
            isDismissed: true
          }));
          posthog.capture(`Insights Trending – Dismiss`, {
            reportId: item.reportId,
            trendId: item.id
          });
        }
      }));
    }
  };
  return /*#__PURE__*/React.createElement(Card, rest, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    element: "h4",
    s: {
      mb: 3,
      pr: 6
    },
    style: {
      flexGrow: 1
    }
  }, itemState.name), /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    weight: "semiBold",
    color: "primary",
    s: {
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "union",
    s: {
      mr: 1.5,
      mt: -0.5
    },
    color: "primary"
  }), itemState.contributionCount, " contributions"), /*#__PURE__*/React.createElement(Box, {
    gap: 2
  }, itemState.isDismissed && /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2
    },
    color: "translucentDanger"
  }, "Dismissed"), /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2
    },
    color: lists.insights.workTypes.colors[itemState.workType]
  }, lists.insights.workTypes.names[itemState.workType]), itemState.isCustomerRelated && /*#__PURE__*/React.createElement(Badge, {
    s: {
      py: 0.5,
      px: 2
    },
    color: "translucent"
  }, "Customer")), isEditable && /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": itemState.isDismissed ? t("common.actions.restore") : t("common.actions.dismiss"),
    onClick: e => {
      e.stopPropagation();
      handleToggleDismiss();
    },
    color: "transparent",
    rounded: true,
    outline: false,
    loading: dismissStatus === StatusStateEnum.LOADING,
    s: {
      p: 2,
      mx: 0.5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: itemState.isDismissed ? "refresh" : "cross",
    color: "text",
    display: "block"
  }))));
};
export default TrendingItemCard;